import { css } from 'styled-components';

export const textStyles = {
  'text-preset-0': () => css`
    font-size: 56px;
    line-height: 64px;
    font-family: Inter;
  `,
  'text-preset-1': () => css`
    font-size: 32px;
    line-height: 40px;
    font-family: Inter;
  `,
  'text-preset-2': () => css`
    font-size: 24px;
    line-height: 32px;
    font-family: Inter;
  `,
  'text-preset-3': () => css`
    font-size: 20px;
    line-height: 30px;
    font-family: Inter;
  `,
  'text-preset-4': () => css`
    font-size: 18px;
    line-height: 28px;
    font-family: Inter;
  `,
  'text-preset-5': () => css`
    font-size: 21px;
    line-height: 23px;
    font-family: Inter;
  `,
  'text-preset-6': () => css`
    font-size: 18px;
    line-height: 21px;
    font-family: Inter;
  `,
  'text-preset-7': () => css`
    font-size: 16px;
    line-height: 18px;
    font-family: Inter;
  `,
  'text-preset-8': () => css`
    font-size: 16px;
    line-height: 18px;
    font-family: Inter;
  `,
  'text-preset-9': () => css`
    font-size: 14px;
    line-height: 16px;
    font-family: Inter;
  `,
  'text-preset-10': () => css`
    font-size: 12px;
    line-height: 14px;
    font-family: Inter;
  `,
  'text-preset-11': () => css`
    font-size: 10px;
    line-height: 12px;
    font-family: Inter;
  `,
};
